import cn from "classnames";
import React from "react";

import buildingSectionStyles from "../../components/BuildingSection/BuildingSection.module.scss";

import Spinner from "shared/ui/atoms/Spinner/Spinner";

import styles from "./BuildingBudgetLoader.module.scss";

const BuildingBudgetLoader: React.FC = () => {
  return (
    <div className={styles.spinnerContainer}>
      <Spinner isSmallGray isStatic />
      <span className={cn(styles.text, buildingSectionStyles.budgetLoaderText)}>Идёт загрузка</span>
    </div>
  );
};

export default BuildingBudgetLoader;
